module.exports = __webpack_public_path__ + "static/media/img1.4e633ab2.png";